export const formatCurrency = (value?: number | null): string => {
	if (value === null || typeof value === "undefined") {
		return "-";
	}
	return new Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "EUR",
	}).format(value);
};

export const formatCurrencyOptional = (value?: number | null): string => {
	if (!value || Number.isNaN(value)) {
		return "";
	}
	return new Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "EUR",
	}).format(value);
};

export const formatCurrencyPrecise = (value?: number | null): string => {
	if (!value || Number.isNaN(value)) {
		return "";
	}
	const isWholeNumber = value % 1 === 0;

	return new Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "EUR",
		useGrouping: true,
		maximumFractionDigits: isWholeNumber ? 0 : 2,
		minimumFractionDigits: 0,
	}).format(value);
};

export const formatNumber = (value: string): string =>
	value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export const unformatNumber = (value: string): string => 
	value.replace(/[^\d]/g, ""); 


export const formatPricing = (price: number) =>
	Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "EUR",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(price);

export const roundTo2Digits = (price: number) => Math.round(price * 100) / 100;

export const roundPricing = (value?: number | null): string => {
	if (value === null || typeof value === "undefined" || Number.isNaN(value)) {
		return "";
	}
	const rounded = Math.round(Number(value) * 100) / 100;
	return rounded.toFixed(2);
};

export function formatNumberWithEuro(value: number | null | undefined): string {
	const numberToFormat =
		value == null || Number.isNaN(value) ? 0 : value;
	const parts = new Intl.NumberFormat("fr-FR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
		useGrouping: true,
	}).formatToParts(numberToFormat);
	const formattedNumber = parts
		.map(({ type, value }) => (type === "decimal" ? "." : value))
		.join("");
	return `${formattedNumber} €`;
}